import {ThemeSelect} from "./Themes/ThemeSelect"
import { useGetSettingQuery } from './Redux/Apis/siteApi'
import Loading from "./Components/Loading"
import Error from "./Components/Error"

function App() {
  const {
    data,
    isLoading,
    isSuccess,
    isError,
    error,
  } = useGetSettingQuery()

  if(isLoading)
    return <Loading/>

  else if(isError)
    return <Error data={error}/>

  else if(isSuccess) {
      document.title = data.name;
      return <ThemeSelect id={data.theme_id}/>
  }
}

export default App;
